export default __webpack_public_path__ + "static/media/CovidTrackerHomePage.b1480bb7.PNG";